import { defineComponent as _defineComponent } from 'vue'
import { useNuxtApp } from '@nuxt/bridge/dist/runtime'
import { computed, ComputedRef, onMounted, ref, watch } from 'vue'
import { Ref } from 'vue/types'
import { convertCurrencyAsPojo } from '~/utility/convertCurrency'
import { formatPrice as fp } from '~/utility/formatCurrency'
import {
  MoneyRaw,
  MoneyType,
  priceToMoneyType,
  SimpleMoney,
} from '~/utility/money'


export default /*#__PURE__*/_defineComponent({
  __name: 'PuPrice',
  props: {
    price: null,
    displayOriginalPrice: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { price: MoneyRaw | MoneyType | SimpleMoney, displayOriginalPrice: boolean };

const { $i18n } = useNuxtApp()



onMounted(async () => {
  if (displayPrice.value.getCurrency() !== $i18n.current.currency) {
    await convertDisplayPriceCurrency()
  }
})

// watch can't be done on props, so we need to use computed
const price = computed(() => {
  return props.price
})

watch(price, async () => {
  await convertDisplayPriceCurrency()
})

const currentCurrency = computed(() => {
  return $i18n.current.currency
})

watch(currentCurrency, async () => {
  await convertDisplayPriceCurrency()
})

const currencyConvertedDisplayPrice: Ref<MoneyRaw | null> = ref(null)

async function convertDisplayPriceCurrency() {
  currencyConvertedDisplayPrice.value = await convertCurrencyAsPojo(
    priceMoney.value,
    $i18n.current.currency,
  )
}

function formatPrice(priceObject: MoneyType) {
  return fp(priceObject, $i18n.locale)
}

const displayPrice: ComputedRef<MoneyType> = computed(() => {
  if (currencyConvertedDisplayPrice.value) {
    return priceToMoneyType(currencyConvertedDisplayPrice.value)
  }
  return priceMoney.value
})

const mainPriceObject: ComputedRef<MoneyType> = computed(() => {
  if (shouldDisplayOriginalPrice.value) {
    return priceMoney.value
  }
  return displayPrice.value
})

const priceMoney: ComputedRef<MoneyType> = computed(() => {
  return priceToMoneyType(props.price)
})

const shouldDisplayOriginalPrice = computed(() => {
  if (props.displayOriginalPrice) {
    return $i18n.current.currency !== priceMoney.value.getCurrency()
  }
  return false
})

return { __sfc: true,$i18n, props, price, currentCurrency, currencyConvertedDisplayPrice, convertDisplayPriceCurrency, formatPrice, displayPrice, mainPriceObject, priceMoney, shouldDisplayOriginalPrice }
}

})